
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31113",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31113",
  "emoji-mart": "static-3.10",
  "feedback-schema": "static-1.55711",
  "head-dlb": "static-1.5344",
  "hs-test-utils": "static-1.8581",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.12028",
  "I18n": "static-7.1724",
  "quartz": "static-1.7758",
  "quartz-config": "static-1.1536",
  "quartz-core": "static-1.6977",
  "react-dlb": "static-1.97",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.88",
  "reselect": "static-3.20",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1162",
  "enviro": "static-4.529",
  "feedback-shared-ui": "static-1.55698",
  "feedback-utils": "static-1.55702",
  "forms-embed-utils-lib": "static-1.5002",
  "forms-utils-lib": "static-1.13427",
  "foundations-assets": "static-1.5428",
  "foundations-components": "static-1.8851",
  "foundations-theming": "static-1.5040",
  "hub-http": "static-1.6744",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12335",
  "icons": "static-2.716",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4267",
  "raven": "static-3.6435",
  "react": "static-7.206",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17278",
  "react-select-plus": "static-1.121",
  "react-utils": "static-2.5718",
  "react-virtualized": "static-2.115",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.521",
  "tinymce-plugins": "static-1.58615",
  "transmute": "static-2.97",
  "ui-images": "static-2.1296",
  "UIComponents": "static-3.8974",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4035",
  "quartz-webpack": "static-1.3982",
  "foundations-theming-specialty": "static-1.2756",
  "property-description-translator": "static-1.4355",
  "HeadJS": "static-2.837",
  "framer-motion": "static-1.87",
  "hs-test-utils-bend-plugin": "static-1.3692",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4844",
  "jasmine-runner": "static-1.6997",
  "opentelemetry-fe-types": "static-1.339",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "hs-browser-apis": "static-1.18",
  "hub-http-janus": "static-1.920",
  "hubspotter-http": "static-1.5013",
  "mobile-manifest-mixins": "static-1.619",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.714",
  "quartz-auth": "static-1.1433",
  "quartz-head": "static-1.1423",
  "quartz-i18n": "static-1.1433",
  "quartz-routing": "static-1.1188",
  "quartz-test": "static-1.1433",
  "quartz-tracking": "static-1.1137",
  "trellis-components": "static-1.3280",
  "ui-fonts": "static-1.1290",
  "usage-tracker-container": "static-1.7871",
  "usage-tracker-core": "static-1.7731",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.426",
  "conversations-skeleton-state": "static-1.7652",
  "sanitize-text": "static-1.8696",
  "PatternValidationJS": "static-1.3415",
  "ReduxMessenger": "static-2.10911",
  "outpost": "static-1.4665",
  "rpc-client-utils": "static-1.5205",
  "reference-resolvers": "static-1.8725",
  "sanitize": "static-1.5007",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5120",
  "floating-ui": "static-1.71",
  "hs-story-utils": "static-1.9963",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.122",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3261",
  "bend-plugin-foundations-theming": "static-1.3523",
  "foundations-theming-base": "static-1.4025",
  "stylex": "static-1.49",
  "hs-locale-management": "static-1.442",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.241",
  "web-vitals": "static-1.22",
  "ai-components-ui-library": "static-1.10131",
  "atom": "static-1.5612",
  "codemirror": "static-5.109",
  "content-assistance-lib": "static-1.8506",
  "ContentUtils": "static-1.69621",
  "data-token-picker": "static-1.17225",
  "file-manager-components": "static-1.24937",
  "FileManagerCore": "static-1.40436",
  "FileManagerLib": "static-1.40577",
  "frontend-preferences-client": "static-1.8462",
  "hub-http-contrib": "static-1.3569",
  "interframe": "static-3.5284",
  "layout-dnd-components": "static-1.13320",
  "layout-dnd-utils": "static-1.12295",
  "property-translator": "static-1.5915",
  "react-codemirror": "static-1.11181",
  "react-colorpicker": "static-2.10748",
  "reference-resolvers-lite": "static-1.8652",
  "rich-text-lib": "static-1.20646",
  "tinymce-data": "static-1.41586",
  "tinymce-themes": "static-1.57471",
  "ui-addon-emoji-picker": "static-1.10403",
  "ui-addon-sales-email": "static-1.5746",
  "ui-brand-identity-lib": "static-1.17100",
  "bender-build-tools": "static-1.3648",
  "opentelemetry-web": "static-1.26",
  "hub-http-shared-msw-handlers": "static-1.11006",
  "hubspotter-http-shared-msw-handlers": "static-1.11004",
  "usage-tracker-session-replay": "static-1.5567",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "trellis-theming": "static-1.1582",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.615",
  "chirp-fetch": "static-1.2439",
  "stylex-utils": "static-1.191",
  "chatspot-core": "static-1.24277",
  "copilot-toolkit": "static-1.12268",
  "customer-data-objects-ui-components": "static-1.13575",
  "data-fetching-client": "static-1.10174",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5294",
  "ui-addon-video-player": "static-1.9161",
  "ui-coaching-tips": "static-1.29642",
  "usage-tracker": "static-1.7881",
  "cms-field-types": "static-1.5352",
  "content-icons-ui": "static-1.2523",
  "integrations-lib": "static-1.17563",
  "customer-data-objects": "static-1.8253",
  "apollo-dlb": "static-3.98",
  "apollo-link-hub-http": "static-2.5128",
  "apollo-stack-hubspot": "static-3.102",
  "breeze-engine-lib": "static-1.2391",
  "graphql": "static-1.96",
  "immer": "static-1.107",
  "immerable": "static-1.4683",
  "poll-commands": "static-1.4015",
  "ui-addon-iframeable": "static-1.9619",
  "video-components-external": "static-1.12553",
  "video-data-lib": "static-1.36211",
  "audio-components": "static-1.6653",
  "breeze-artifacts-sdk": "static-1.1218",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30150",
  "FileManagerImages": "static-1.38088",
  "foundations-components-legacy": "static-1.1876",
  "html-to-image": "static-1.68",
  "redux-toolkit": "static-1.85",
  "salesImages": "static-1.797",
  "ui-universal-auth": "static-1.9863",
  "urlinator": "static-1.5056",
  "video-components": "static-1.14555",
  "video-embed": "static-1.37045",
  "ts-schema": "static-1.4433",
  "ContentData": "static-1.69696",
  "layout-data-lib": "static-1.10620",
  "react-dnd-compat": "static-1.5149",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2089",
  "external-options-client-types": "static-1.4478",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6129",
  "hs-resources": "static-1.735",
  "inbound-db-properties-service-client": "static-1.4190",
  "NamespacedHubStyle": "static-2.9407",
  "growth-onboarding-confetti": "static-1.3595",
  "SharedI18nStrings": "static-1.191",
  "ui-addon-i18n": "static-1.11686",
  "amplitude-session-replay-browser": "static-1.80",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5962",
  "magpie-types": "static-1.5422",
  "simple-logging-lib": "static-1.3586",
  "avatar-components": "static-1.3027",
  "customer-data-ui-utilities": "static-1.10372",
  "growth-onboarding-feedback-components": "static-1.7124",
  "flux-actions": "static-1.384",
  "hubspot-apollo-client": "static-1.5415",
  "integrations-error-boundary-lib": "static-1.14978",
  "integrations-tracking-lib": "static-1.6167",
  "laboratory-lib": "static-3.7687",
  "native-integrations-shared-strings": "static-1.8297",
  "redux-observable": "static-1.82",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10826",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1369",
  "breeze-engine-core": "static-1.1669",
  "highlight.js": "static-1.93",
  "pulse": "static-1.1208",
  "navigation-messaging": "static-1.8649",
  "content-media-composition-data-lib": "static-1.13693",
  "content-media-compositions": "static-2.17700",
  "idb-keyval": "static-1.58",
  "media-bridge-lib": "static-1.19731",
  "nudge-client-utils": "static-1.3511",
  "custom-vendor-connection-lib": "static-1.427",
  "unified-auth-core-lib": "static-1.1659",
  "social-insights-client-types": "static-1.23046",
  "advanced-menus-core": "static-1.15911",
  "advanced-menus-lib": "static-1.12641",
  "ExportDialog": "static-6.10913",
  "ui-memberships-settings-lib": "static-1.35331",
  "conditional-properties-service-client": "static-1.4150",
  "crm-pipelines-api-client-types": "static-1.4484",
  "event-emitter": "static-1.1499",
  "fdsr-migration-layer": "static-1.553",
  "framework-builder-read-service-client": "static-1.4374",
  "inbound-db-meta-service-client": "static-1.3810",
  "multi-currency-client-types": "static-1.4049",
  "foundations-components-test-utils": "static-1.6334",
  "reactive-lib": "static-1.1261",
  "trellis-migration-context": "static-1.117",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.874",
  "universal-page-editor-lib": "static-1.3559",
  "bend-plugin-pulse": "static-1.711",
  "fast-json-patch": "static-1.77",
  "nav-meta": "static-1.30959",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3268",
  "nudge-renderer-utils": "static-1.3587",
  "onboarding-tours": "static-1.17483",
  "whisper-core-api": "static-1.7741",
  "fsm": "static-1.4300",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15910",
  "simple-menus-lib": "static-1.17427",
  "settings-ui-lib": "static-1.13071",
  "persist-promise": "static-1.4246",
  "crm-record-cards-client": "static-1.232",
  "crm-record-cards-service-types": "static-1.3895",
  "framework-data-schema-resolvers": "static-1.7432",
  "location-customization-utils-lib": "static-1.10560",
  "getting-started-shared-tasks": "static-1.19663",
  "growth-data-modal": "static-1.6218",
  "growth-onboarding-next-action-utils": "static-1.3101",
  "navigation-components": "static-1.19322",
  "nest": "static-1.777",
  "onboarding-tours-client": "static-1.5698",
  "onboarding-tours-utils": "static-1.1550",
  "ui-shepherd-tracker": "static-1.8207",
  "user-context": "static-1.5597",
  "react-flip-move": "static-1.86",
  "framework-data-schema-quick-fetch": "static-1.7337",
  "onboarding-data-sync-lib": "static-1.2923",
  "growth-onboarding-next-action-components": "static-1.3129",
  "user-context-client": "static-1.5046",
  "getting-started-shared-tasks-store": "static-1.18781",
  "InboxConnectUtils": "static-4.15958",
  "meetings-connect-utils-lib": "static-1.8158",
  "onboarding-scopes": "static-1.6991"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31113",
  "emoji-mart": "/emoji-mart/static-3.10",
  "feedback-schema": "/feedback-schema/static-1.55711",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-test-utils": "/hs-test-utils/static-1.8581",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.12028",
  "I18n": "/I18n/static-7.1724",
  "quartz": "/quartz/static-1.7758",
  "quartz-config": "/quartz-config/static-1.1536",
  "quartz-core": "/quartz-core/static-1.6977",
  "react-dlb": "/react-dlb/static-1.97",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.88",
  "reselect": "/reselect/static-3.20",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1162",
  "enviro": "/enviro/static-4.529",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55698",
  "feedback-utils": "/feedback-utils/static-1.55702",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.5002",
  "forms-utils-lib": "/forms-utils-lib/static-1.13427",
  "foundations-assets": "/foundations-assets/static-1.5428",
  "foundations-components": "/foundations-components/static-1.8851",
  "foundations-theming": "/foundations-theming/static-1.5040",
  "hub-http": "/hub-http/static-1.6744",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12335",
  "icons": "/icons/static-2.716",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4267",
  "raven": "/raven/static-3.6435",
  "react": "/react/static-7.206",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17278",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-utils": "/react-utils/static-2.5718",
  "react-virtualized": "/react-virtualized/static-2.115",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "tinymce-plugins": "/tinymce-plugins/static-1.58615",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1296",
  "UIComponents": "/UIComponents/static-3.8974",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4035",
  "quartz-webpack": "/quartz-webpack/static-1.3982",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2756",
  "property-description-translator": "/property-description-translator/static-1.4355",
  "HeadJS": "/HeadJS/static-2.837",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3692",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4844",
  "jasmine-runner": "/jasmine-runner/static-1.6997",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.339",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.619",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.714",
  "quartz-auth": "/quartz-auth/static-1.1433",
  "quartz-head": "/quartz-head/static-1.1423",
  "quartz-i18n": "/quartz-i18n/static-1.1433",
  "quartz-routing": "/quartz-routing/static-1.1188",
  "quartz-test": "/quartz-test/static-1.1433",
  "quartz-tracking": "/quartz-tracking/static-1.1137",
  "trellis-components": "/trellis-components/static-1.3280",
  "ui-fonts": "/ui-fonts/static-1.1290",
  "usage-tracker-container": "/usage-tracker-container/static-1.7871",
  "usage-tracker-core": "/usage-tracker-core/static-1.7731",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.426",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7652",
  "sanitize-text": "/sanitize-text/static-1.8696",
  "PatternValidationJS": "/PatternValidationJS/static-1.3415",
  "ReduxMessenger": "/ReduxMessenger/static-2.10911",
  "outpost": "/outpost/static-1.4665",
  "rpc-client-utils": "/rpc-client-utils/static-1.5205",
  "reference-resolvers": "/reference-resolvers/static-1.8725",
  "sanitize": "/sanitize/static-1.5007",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5120",
  "floating-ui": "/floating-ui/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9963",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.122",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3261",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3523",
  "foundations-theming-base": "/foundations-theming-base/static-1.4025",
  "stylex": "/stylex/static-1.49",
  "hs-locale-management": "/hs-locale-management/static-1.442",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.241",
  "web-vitals": "/web-vitals/static-1.22",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10131",
  "atom": "/atom/static-1.5612",
  "codemirror": "/codemirror/static-5.109",
  "content-assistance-lib": "/content-assistance-lib/static-1.8506",
  "ContentUtils": "/ContentUtils/static-1.69621",
  "data-token-picker": "/data-token-picker/static-1.17225",
  "file-manager-components": "/file-manager-components/static-1.24937",
  "FileManagerCore": "/FileManagerCore/static-1.40436",
  "FileManagerLib": "/FileManagerLib/static-1.40577",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8462",
  "hub-http-contrib": "/hub-http-contrib/static-1.3569",
  "interframe": "/interframe/static-3.5284",
  "layout-dnd-components": "/layout-dnd-components/static-1.13320",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12295",
  "property-translator": "/property-translator/static-1.5915",
  "react-codemirror": "/react-codemirror/static-1.11181",
  "react-colorpicker": "/react-colorpicker/static-2.10748",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8652",
  "rich-text-lib": "/rich-text-lib/static-1.20646",
  "tinymce-data": "/tinymce-data/static-1.41586",
  "tinymce-themes": "/tinymce-themes/static-1.57471",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10403",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5746",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17100",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11006",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11004",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5567",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "trellis-theming": "/trellis-theming/static-1.1582",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.615",
  "chirp-fetch": "/chirp-fetch/static-1.2439",
  "stylex-utils": "/stylex-utils/static-1.191",
  "chatspot-core": "/chatspot-core/static-1.24277",
  "copilot-toolkit": "/copilot-toolkit/static-1.12268",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13575",
  "data-fetching-client": "/data-fetching-client/static-1.10174",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5294",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9161",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29642",
  "usage-tracker": "/usage-tracker/static-1.7881",
  "cms-field-types": "/cms-field-types/static-1.5352",
  "content-icons-ui": "/content-icons-ui/static-1.2523",
  "integrations-lib": "/integrations-lib/static-1.17563",
  "customer-data-objects": "/customer-data-objects/static-1.8253",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5128",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.102",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2391",
  "graphql": "/graphql/static-1.96",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4683",
  "poll-commands": "/poll-commands/static-1.4015",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9619",
  "video-components-external": "/video-components-external/static-1.12553",
  "video-data-lib": "/video-data-lib/static-1.36211",
  "audio-components": "/audio-components/static-1.6653",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1218",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30150",
  "FileManagerImages": "/FileManagerImages/static-1.38088",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1876",
  "html-to-image": "/html-to-image/static-1.68",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "salesImages": "/salesImages/static-1.797",
  "ui-universal-auth": "/ui-universal-auth/static-1.9863",
  "urlinator": "/urlinator/static-1.5056",
  "video-components": "/video-components/static-1.14555",
  "video-embed": "/video-embed/static-1.37045",
  "ts-schema": "/ts-schema/static-1.4433",
  "ContentData": "/ContentData/static-1.69696",
  "layout-data-lib": "/layout-data-lib/static-1.10620",
  "react-dnd-compat": "/react-dnd-compat/static-1.5149",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2089",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6129",
  "hs-resources": "/hs-resources/static-1.735",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4190",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9407",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3595",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11686",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5962",
  "magpie-types": "/magpie-types/static-1.5422",
  "simple-logging-lib": "/simple-logging-lib/static-1.3586",
  "avatar-components": "/avatar-components/static-1.3027",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10372",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7124",
  "flux-actions": "/flux-actions/static-1.384",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5415",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14978",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6167",
  "laboratory-lib": "/laboratory-lib/static-3.7687",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8297",
  "redux-observable": "/redux-observable/static-1.82",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10826",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1369",
  "breeze-engine-core": "/breeze-engine-core/static-1.1669",
  "highlight.js": "/highlight.js/static-1.93",
  "pulse": "/pulse/static-1.1208",
  "navigation-messaging": "/navigation-messaging/static-1.8649",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13693",
  "content-media-compositions": "/content-media-compositions/static-2.17700",
  "idb-keyval": "/idb-keyval/static-1.58",
  "media-bridge-lib": "/media-bridge-lib/static-1.19731",
  "nudge-client-utils": "/nudge-client-utils/static-1.3511",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.427",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1659",
  "social-insights-client-types": "/social-insights-client-types/static-1.23046",
  "advanced-menus-core": "/advanced-menus-core/static-1.15911",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12641",
  "ExportDialog": "/ExportDialog/static-6.10913",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35331",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4150",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4484",
  "event-emitter": "/event-emitter/static-1.1499",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.553",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3810",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4049",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6334",
  "reactive-lib": "/reactive-lib/static-1.1261",
  "trellis-migration-context": "/trellis-migration-context/static-1.117",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.874",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3559",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.711",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "nav-meta": "/nav-meta/static-1.30959",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3268",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3587",
  "onboarding-tours": "/onboarding-tours/static-1.17483",
  "whisper-core-api": "/whisper-core-api/static-1.7741",
  "fsm": "/fsm/static-1.4300",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15910",
  "simple-menus-lib": "/simple-menus-lib/static-1.17427",
  "settings-ui-lib": "/settings-ui-lib/static-1.13071",
  "persist-promise": "/persist-promise/static-1.4246",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.232",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3895",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10560",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19663",
  "growth-data-modal": "/growth-data-modal/static-1.6218",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3101",
  "navigation-components": "/navigation-components/static-1.19322",
  "nest": "/nest/static-1.777",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5698",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1550",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8207",
  "user-context": "/user-context/static-1.5597",
  "react-flip-move": "/react-flip-move/static-1.86",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2923",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3129",
  "user-context-client": "/user-context-client/static-1.5046",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18781",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15958",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8158",
  "onboarding-scopes": "/onboarding-scopes/static-1.6991"
}
};
